export const selectSupplierServiceTypes = (state) => state.supplierServiceTypes.supplierServiceTypes;

export const selectSupplierServiceTypesLoading = (state) => state.supplierServiceTypes.loading;

export const selectSupplierServiceTypesPag = (state) => state.supplierServiceTypes.supplierServiceTypesPag;

export const selectSupplierServiceTypesLoadingPag = (state) => state.supplierServiceTypes.loadingPag;